import { SurveyManager } from './survey-manager';
import { setSurveyHasCampaign } from './util';

export const setupSurveyManager = (({
  i18n,
  serverContext,
  PreferenceService,
  tokenInfo,
  surveyList,
  appActivity,
  activityName,
  appPerfMarker,
}) => {
  // set up global variables
  window.survey = {
    hasCampaign: false,
    setSurveyHasCampaign,
  };

  window.survey.surveyManager = SurveyManager({
    i18n,
    serverContext,
    PreferenceService,
    tokenInfo,
    surveyList,
    appActivity,
    activityName,
    appPerfMarker,
  });
});
